
































import { Component, Mixins } from "vue-property-decorator";

// Mixins
import CrossSellProvider from "@/components/app/global/baskets/basket/crossSell/crossSellProvider";
import { ShopItemsLayout } from "@/data/shop/enums";

@Component({
  components: {
    "shop-products-list": () =>
      import("@/components/app/global/baskets/basket/shop/shopProductsList.vue")
  }
})
export default class CrossSellsModal extends Mixins(CrossSellProvider) {
  public get itemsLayout() {
    return this.crossSells.length < 3
      ? ShopItemsLayout.HORIZONTAL
      : ShopItemsLayout.VERTICAL;
  }
}
